export var baseApiUrl = "https://nmci.upintelligence.es"
// export var baseApiUrl = "http://localhost:8080"